<template>
  <div>
    <!-- カード -->
    <div class="rounded border border-co-gray-950/[.125] bg-white">
      <h3 class="co-display-12 mb-0 border-b border-co-gray-950/[.125] bg-co-gray-950/[.03] px-5 py-3">
        <slot name="cardHeader">
          カードヘッダー
        </slot>
      </h3>
      <div class="p-5">
        <p>
          <slot name="cardBody">
            カードのコンテンツ
          </slot>
        </p>
      </div>
    </div>
    <!-- 矢印 -->
    <div
      v-if="arrow"
      class="co-display-6 my-3 text-center text-co-gray-500"
    >
      <FontAwesomeIcon
        :icon="faChevronDown"
        class="fa-fw inline size-8"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faChevronDown,
    }
  },
  props: {
    arrow: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
